/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G2_TInputs */

const en_mk_sec_pg_g2_t = /** @type {(inputs: Mk_Sec_Pg_G2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A spending cap`)
};

const id_mk_sec_pg_g2_t = /** @type {(inputs: Mk_Sec_Pg_G2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas belanja`)
};

/**
* | output |
* | --- |
* | "A spending cap" |
*
* @param {Mk_Sec_Pg_G2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g2_t = /** @type {((inputs?: Mk_Sec_Pg_G2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g2_t(inputs)
	return en_mk_sec_pg_g2_t(inputs)
});